import router from '@/router';
import { LocationQueryRaw } from 'vue-router';

function pageOpen(path: string, query?: LocationQueryRaw) {
  if (!path.startsWith('/')) {
    path = `/${path}`;
  }
  router.push({
    path,
    query,
  });
}

export default pageOpen;
